import I18N from '@leverege/i18n';
const {
  t,
  tf
} = I18N.ns('molten.dataViewers.layout.DefaultLayoutAction');
export default {
  id: 'molten.dataViewers.layout.DefaultLayoutAction',
  name: tf('name'),
  matches: {
    use: 'mobileLayoutActionBar'
  },
  layout: {
    sort: 'd.1'
  },
  handles: context => true,
  appearance: ({
    context
  }) => {
    const {
      layout: {
        layoutId
      }
    } = context;
    const name = t('name');
    const checked = layoutId == null || layoutId === 'none';
    return {
      name,
      checkStyle: 'toggle',
      checked
    };
  },
  perform: ({
    context
  }) => {
    const {
      layout: {
        onLayoutChange
      }
    } = context;
    const value = 'none';
    const data = {
      group: null,
      version: null
    };
    onLayoutChange({
      value,
      data,
      isReplace: false
    });
  }
};